
import { Component, Vue } from 'vue-property-decorator';
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

@Component({
    components:{
        ExpandIcon
    }
})
export default class FactumAppealBookRspToLeaveGrantedPg extends Vue {

    showFactumInfo = true;
    showTranscriptInfo = false;    
    showCertificateInfo = false;
    showReplyInfo = false;
    showNoticeInfo = false;   
    
    appealBookHelpText = '<div>If you would like to provide information that is not included in the appellant’s Appeal Book, please complete your own Appeal Book.</div>';
    transcriptExtractBookHelpText = '<div>If a witness spoke at your original trial or hearing, and you mentioned this oral testimony in your Factum, you will need to complete a Transcript Extract Book.</div>';

    public showFactum(show: boolean){
        if (show) {
            this.showFactumInfo = true;
            this.$emit('adjustHeights', 0, "17rem");
        } else {
            this.showFactumInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showTranscript(show: boolean){
        if (show) {
            this.showTranscriptInfo = true;
            this.$emit('adjustHeights', 1, "3rem");
        } else {
            this.showTranscriptInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

     public showCertificate(show: boolean){
        if (show) {
            this.showCertificateInfo = true;
            this.$emit('adjustHeights', 2, "16rem");
        } else {
            this.showCertificateInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showReply(show: boolean){
        if (show) {
            this.showReplyInfo = true;
            this.$emit('adjustHeights', 3, "2rem");
        } else {
            this.showReplyInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

    public showNotice(show: boolean){
        if (show) {
            this.showNoticeInfo = true;
            this.$emit('adjustHeights', 4, "8rem");
        } else {
            this.showNoticeInfo = false;
            this.$emit('adjustHeights', 4, "0");
        }
    }  

}
